import { formatScore } from "@/lib/format";

/**
 * Compact 0-100 progress bar with the value on the right. Color shifts
 * with the score band so a glance carries the message even on
 * grayscale screens.
 */
export function HealthScoreBar({
  value,
  confidence,
}: {
  value: number;
  confidence?: number;
}) {
  const clamped = Math.max(0, Math.min(100, value));
  const band =
    clamped >= 70 ? "bg-curate-success"
    : clamped >= 40 ? "bg-curate-warn"
    : "bg-curate-danger";

  return (
    <div className="flex items-center gap-2">
      <div className="relative h-1.5 w-28 overflow-hidden rounded-full bg-curate-mist">
        <div
          className={`absolute inset-y-0 left-0 ${band}`}
          style={{ width: `${clamped}%` }}
        />
      </div>
      <span className="font-mono text-xs text-curate-ink">{formatScore(value)}</span>
      {confidence != null && (
        <span
          title={`confidence ${(confidence * 100).toFixed(0)}%`}
          className="text-2xs text-curate-slate"
        >
          ±{Math.round((1 - confidence) * 50)}
        </span>
      )}
    </div>
  );
}
